import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { DISMISS_FAILED, DISMISS_STARTED, DISMISS_SUCCEEDED } from '../../common/constants';
import { useACTAnalyticsEvents } from '../../common/utils';
import { useAdControlProvider } from '../../controllers';
import { messages } from '../messages';
const interactedUIEventAction = {
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'notInterested'
};
const DismissalButton = ({
  itemId,
  onClick,
  children,
  flagProps,
  ...props
}) => {
  const {
    addFlag,
    createEventDispatcher,
    shouldShowDismissFlag
  } = useAdControlProvider();
  const {
    createInteractedUIEvent
  } = useACTAnalyticsEvents();
  const eventDispatcher = React.useMemo(() => createEventDispatcher(itemId), [createEventDispatcher, itemId]);
  const handleOnClick = React.useCallback(async e => {
    eventDispatcher.dispatch(DISMISS_STARTED, createInteractedUIEvent(interactedUIEventAction));
    shouldShowDismissFlag && addFlag(itemId, flagProps);
    try {
      await (onClick === null || onClick === void 0 ? void 0 : onClick(e, itemId));
      eventDispatcher.dispatch(DISMISS_SUCCEEDED);
    } catch (e) {
      eventDispatcher.dispatchError(DISMISS_FAILED, e);
    }
  }, [addFlag, createInteractedUIEvent, eventDispatcher, flagProps, itemId, onClick, shouldShowDismissFlag]);
  return /*#__PURE__*/React.createElement(DropdownItem, _extends({
    onClick: handleOnClick
  }, props), children !== null && children !== void 0 ? children : /*#__PURE__*/React.createElement(FormattedMessage, messages.notInterested));
};
export default DismissalButton;